export const sizes = {
  xxs: { size: 14, stroke: 1.2 },
  xs: { size: 16, stroke: 1.6 },
  sm: { size: 20, stroke: 2.3 },
  md: { size: 24, stroke: 3 },
  lg: { size: 32, stroke: 4 },
  xl: { size: 40, stroke: 5 },
  xxl: { size: 48, stroke: 6 },
};
